import React from "react";
import {Arrow} from "BaseComponents/Icons/Svg";
import {BreadcrumbsLink, BreadcrumbsLinkContainer, BreadcrumbsWrapper} from "./Breadcrumbs.styles";
import media from "styled-media-query";
import breakpoints from "Framework/helpers/BreakpointHelper";
import {useGlobal} from "reactn";
import styled from "styled-components";

export const Line = styled.span`
	background-color: ${({ theme }) => theme.colors.bg2};
	width: 100%;
	height: 2px;
	margin-top: 20px;
	${media.lessThan(breakpoints.mobile)`
margin-top: 5px;
height: 1px;`}
`;
export const Breadcrumbs = ({ PageName, PageUrl }) => {
	const [theme] = useGlobal("theme");

	return PageName != undefined ? (
		<BreadcrumbsWrapper smallwidth="unset" width="unset">
			<BreadcrumbsLinkContainer>
				<Arrow
					color={theme.colors.primary}
					invert="rotate(180deg)"
					size="15px"
					margin="0 2px 0 0"
					smalldisplay="block"
				/>
				<BreadcrumbsLink href={PageUrl} text={PageName}></BreadcrumbsLink>
			</BreadcrumbsLinkContainer>
			<Line />
		</BreadcrumbsWrapper>
	) : (
		<></>
	);
};
